/*** IMPORTS FROM imports-loader ***/
var define = false;

"use strict";

/**
 * Converts list into array
 */
module.exports = Array.from;
